(function () {
  'use strict';

  function activateTab(root, tabId) {
    var buttons = root.querySelectorAll('.maxis-product-tabs__btn');
    var panels = root.querySelectorAll('.maxis-product-tabs__panel');
    buttons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-maxis-tab') === tabId;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      btn.setAttribute('tabindex', isActive ? '0' : '-1');
    });
    panels.forEach(function (panel) {
      var isActive = panel.getAttribute('data-maxis-panel') === tabId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-maxis-product-tabs] .maxis-product-tabs__btn');
    if (!btn) return;
    var root = btn.closest('[data-maxis-product-tabs]');
    var tabId = btn.getAttribute('data-maxis-tab');
    if (!root || !tabId) return;
    activateTab(root, tabId);
    btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });

  document.addEventListener('keydown', function (e) {
    var btn = e.target.closest('[data-maxis-product-tabs] .maxis-product-tabs__btn');
    if (!btn) return;
    var root = btn.closest('[data-maxis-product-tabs]');
    if (!root) return;
    var buttons = Array.prototype.slice.call(root.querySelectorAll('.maxis-product-tabs__btn'));
    var currentIndex = buttons.indexOf(btn);
    var nextIndex = null;
    if (e.key === 'ArrowRight') nextIndex = (currentIndex + 1) % buttons.length;
    else if (e.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + buttons.length) % buttons.length;
    else if (e.key === 'Home') nextIndex = 0;
    else if (e.key === 'End') nextIndex = buttons.length - 1;
    else return;
    e.preventDefault();
    var next = buttons[nextIndex];
    next.focus();
    activateTab(root, next.getAttribute('data-maxis-tab'));
  });
})();
